export class PutActualizarHoraJornadaResquestDTO {

  fechaInicio: string;
  fechaTermino: string;

}
